import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
//import columns from './columns';
import SaveIcon from '@material-ui/icons/Save';


import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  TableContainer,
  Paper,
  Button
  
} from '@material-ui/core';


const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 550,
  },
});


export default props => {
 
   //const renderRows =() => {
      const classes = useStyles();
      const [limit, setLimit] = useState(10);
      const [page, setPage] = useState(0);
      //const rows = props.rows || [];
      //const classes = useStyles();
      const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(0);
      };

      const handlePageChange = (event, newPage) => {
        setPage(newPage);
      };

        
        return (
          <Card>
                
     
                <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          Loja
                        </TableCell>
                        <TableCell>
                          Cliente
                        </TableCell>
                        <TableCell>
                          Num. NF. DANFE
                        </TableCell>
                        <TableCell>
                          Série
                        </TableCell>
                        <TableCell>
                          Data de Emissão
                        </TableCell>
                        <TableCell>
                          Pedido Caixa Fácil
                        </TableCell>
                        <TableCell>
                          Status
                        </TableCell>
                        <TableCell>
                          
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      { props.rows.slice(page * limit, page * limit + limit).map((itens => (          
                        
                        <TableRow
                          hover
                          key={itens.id}
                        >
                          <TableCell>
                            <Box
                              alignItems="center"
                              display="flex"
                            >
                              <Typography
                                color="textPrimary"
                                variant="body1"
                              >
                                {itens.codigo_loja}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            {itens.des_nome}
                          </TableCell>
                          <TableCell>
                            {itens.numero_danfe}
                          </TableCell>
                          <TableCell>
                            {itens.serie}
                          </TableCell>

                          <TableCell>
                          {itens.data_emissao}
                          </TableCell>
                          <TableCell>
                            {itens.pedido}
                          </TableCell>
                          <TableCell>
                          {itens.status}
                          </TableCell>
                          <TableCell>
                          <Button variant="outlined" color="primary" data-toggle="tooltip" data-placement="top" title="Envia o Pedido ao Caixa Fácil" startIcon={<SaveIcon />} onClick={()=> props.handleApi(itens)}>Gerar Pedido</Button>
                          </TableCell>
                        </TableRow>
                      )))}
                    </TableBody>
                  </Table>
                  </TableContainer>
                
                
              <TablePagination
                component="div"
                count={props.rows.length}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleLimitChange}
                page={page}
                rowsPerPage={limit}
                rowsPerPageOptions={[5, 10, 25]}
              />
               {/* <CSVLink data={props.rows} separator={";"} headers={headers} className="btn btn-outline-dark" >Exportar</CSVLink> */}
               </Paper>
            </Card>
  
          )
}